import React, { useEffect, useState, useContext, useMemo } from "react";
import CenterContainer from "../components/CenterContainer";
import Title from "../components/Title";
import AuthContext from "../AuthContext";
import { Link, Prompt, useHistory } from "react-router-dom";
import Button from "../components/Button";
import TestCard from "../components/TestCard";
import {
    faArrowRight,
    faInfoCircle,
    faKey,
    faPiggyBank,
    faSignOutAlt,
    faSmile,
    faThumbsUp,
    faTimes,
    faUser,
    faUserCog,
    faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import UserCard from "../components/UserCard";
import Alert from "../components/Alert";
import Spinner from "../components/Spinner";
import { getColorForRegistrationStatus, getIconForRegistrationStatus, RegistrationStatusBadge } from "../components/Badge";
import styled from "styled-components";
import { useLanguage } from "../useLanguage";
import Footer from "../components/Footer";
import { Event, EventReservation, Registration, User } from "consumerhouse-shared";
import { EventCard } from "../components/EventCard";
import { FriendInviteCard } from "../components/FriendInviteCard";
import { LinkButton } from "../components/LinkButton";
import { Facebook as LoadingAccount } from "react-content-loader";
import { CollapseContainer } from "../components/CollapseContainer";
import { ButtonContainer } from "../components/ButtonContainer";
import { UndrawContainer } from "../components/UndrawContainer";
import { ReactComponent as UndrawNoData } from "../data/undraw_no_data.svg";

const Reservation = styled.div`
    margin: 1em 0.5em;
    display: inline-flex;
    flex-direction: column;
`;

const UserContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin: 1.5em 0;
`;

// const TestStatusText = styled.p<{ color: string }>`
//     color: white;
//     border-radius: 0.3em;
//     font-weight: bold;
//     background: ${(p) => p.color};
//     padding: 0.3em 0.5em;
// `;

export default function Account() {
    const { client, setAuth, auth } = useContext(AuthContext);
    const history = useHistory();
    const language = useLanguage();
    const [registrations, setRegistrations] = useState<Registration[] | null>(null);
    const [friendInvites, setFriendInvites] = useState<User[]>([]);
    const doneFriendInvites = useMemo(() => friendInvites.filter((e) => e.registrations!.length > 0), [friendInvites]);

    let user = auth!.user;

    useEffect(() => {
        client.fetch("/user/friendinvites").then((e) => setFriendInvites(e.users));
        client.fetch("/user/registrations").then((e) => setRegistrations(e.registrations));
    }, [client]);

    return (
        <>
            <CenterContainer style={{ minHeight: "80vh", margin: "2em 0" }}>
                <Title>{language("account")}</Title>
                <ButtonContainer>
                    <Button
                        onClick={() => {
                            setAuth(null);
                            history.push("/");
                        }}
                        icon={faSignOutAlt}>
                        {language("account-logout")}
                    </Button>
                    <Button color="#666" onClick={() => history.push("/account/edit")} icon={faUserCog}>
                        {language("account-edit-account")}
                    </Button>
                    <Button color="#666" onClick={() => history.push("/change-password")} icon={faKey}>
                        {language("account-change-password")}
                    </Button>
                </ButtonContainer>

                <div>
                    {/* <CollapseContainer
                        style={{ margin: "1em 0.3em", maxWidth: "calc(100% - 0.3em)" }}
                        title={user.firstName + " " + user.lastName}
                        icon={faUser}
                    >
                        <UserCard style={{ display: "inline-flex", margin: "1em 0" }} admin={user.admin} user={user} />
                        <Button
                            style={{ display: "block" }}
                            color="#666"
                            onClick={() => history.push("/account/edit")}
                            icon={faUserCog}
                        >
                            {language("account-edit-account")}
                        </Button>
                    </CollapseContainer> */}

                    <UserContainer>
                        <UserCard style={{ display: "inline-flex", margin: "0 0.5em 0.5em 0" }} admin={user.admin} user={user} />
                        <FriendInviteCard
                            style={{ display: "inline-flex", flexGrow: 1, fontSize: "0.8em", margin: "0 0 0.5em 0.5em" }}
                            registerFriendId={auth!.user.id}
                        />
                    </UserContainer>

                    {registrations ? (
                        <>
                            {registrations.reduce((p, e) => p.concat(e.reservations!), [] as EventReservation[]).length > 0 && (
                                <>
                                    <Title>{language("account-reservations")}</Title>
                                    <p>{language("account-reservations-info")}</p>
                                    {registrations.map((registration) =>
                                        registration.reservations!.map((reservation) => (
                                            <Reservation key={reservation.id}>
                                                <Alert style={{ maxWidth: "310px" }} color="#56a44f" icon={faInfoCircle}>
                                                    <div>
                                                        <p>
                                                            {language("account-reservation-expect1")} <strong>{reservation.event!.title}</strong>{" "}
                                                            {language("account-reservation-expect2")}
                                                        </p>
                                                        <ul>
                                                            <li>
                                                                {language("account-reservation-expect3")}{" "}
                                                                <strong>{new Date(reservation.timestamp!.timeStamp).toLocaleDateString()}</strong>
                                                            </li>
                                                            <li>
                                                                {language("account-reservation-expect4")}{" "}
                                                                <strong>{new Date(reservation.timestamp!.timeStamp).toLocaleTimeString()}</strong>
                                                            </li>
                                                            <li>
                                                                {language("account-reservation-expect5")}{" "}
                                                                <strong>{reservation.timestamp!.location!.address}</strong>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </Alert>
                                                <Button
                                                    icon={faTimes}
                                                    style={{ margin: "0.5em 0 0 0", fontSize: "0.8em" }}
                                                    onClick={async () => {
                                                        if (
                                                            !window.confirm(
                                                                `${language("account-reservation-cancel-confirm")} '${reservation.event!.title}'?`
                                                            )
                                                        )
                                                            return;

                                                        await client.fetch("/event/cancelreserve", {
                                                            eventId: reservation.eventId,
                                                            userId: reservation.userId,
                                                        });
                                                        // Refresh the page
                                                        window.location.href = window.location.href;
                                                    }}
                                                    color="#666">
                                                    {language("account-reservation-cancel")}
                                                </Button>
                                            </Reservation>
                                        ))
                                    )}
                                </>
                            )}

                            {registrations.filter((e) => e.satisfies).reduce((p, e) => p.concat(e.test!.events!), [] as Event[]).length > 0 && (
                                <>
                                    <Title>{language("account-pending-reservations")}</Title>
                                    {/* <h2 style={{ margin: "0.5em 0" }}>{language("account-pending-reservations")}</h2> */}
                                    <p>{language("account-pending-reservations-info")}</p>
                                    {registrations
                                        .filter((e) => e.satisfies)
                                        .map((registration) =>
                                            registration.test!.events!.map((event) => (
                                                <EventCard
                                                    key={event.id}
                                                    style={{ margin: "0.5em 0.5em 0.5em 0" }}
                                                    event={{ ...event, test: registration.test! }}>
                                                    <Button
                                                        icon={faArrowRight}
                                                        style={{ margin: "0.5em 0 0 0", fontSize: "0.8em" }}
                                                        onClick={() => history.push(`/reserve/${event.id}`)}>
                                                        {language("account-pending-reservations-reserve")}
                                                    </Button>
                                                </EventCard>
                                            ))
                                        )}
                                </>
                            )}

                            {friendInvites.length > 0 && (
                                <Alert icon={faPiggyBank} color="#eee" textColor="black">
                                    <p style={{ maxWidth: "400px" }}>
                                        {language("account-friendinvites1")} <strong>{friendInvites.length}</strong>
                                        {language("account-friendinvites2")}
                                        <strong>{doneFriendInvites.length}</strong> {language("account-friendinvites3")}
                                        <strong>€{doneFriendInvites.length * 5}</strong> {language("account-friendinvites4")}
                                    </p>
                                </Alert>
                            )}

                            {/* {registrations!.length > 0 && <Title>{language("account-enrolled")}</Title>} */}
                            {registrations!.length === 0 && (
                                <UndrawContainer style={{ margin: "6em 0" }}>
                                    <UndrawNoData />
                                    <p style={{ marginTop: "1em" }}>{language("account-no-tests")}</p>
                                    <Link to="/">
                                        <p>{language("account-no-tests-link")}</p>
                                    </Link>
                                </UndrawContainer>
                            )}

                            <div style={{ marginTop: "2em" }}>
                                {registrations!.map((registration) => (
                                    <TestCard
                                        borderIcon={getIconForRegistrationStatus(registration.status)}
                                        borderColor={getColorForRegistrationStatus(registration.status)}
                                        borderContent={language(("account-test-status-" + registration.status) as any)}
                                        key={registration.test!.id}
                                        style={{ margin: "1.5em 0" }}
                                        // badge={<RegistrationStatusBadge status={registration.status} />}
                                        showReward={["waiting", "running", "done"].includes(registration.status)}
                                        test={registration.test!}>
                                        <div>
                                            {["waiting", "running"].includes(registration.status) && (
                                                <p style={{ margin: "0.5em 0" }}>
                                                    <LinkButton
                                                        onClick={async () => {
                                                            if (
                                                                !window.confirm(
                                                                    language("account-test-cancel-confirm").replace("{test}", registration.test!.name)
                                                                )
                                                            )
                                                                return;
                                                            await client.fetch("/test/registration/cancel", { testId: registration.testId });
                                                            setRegistrations(registrations.filter((e) => e.testId !== registration.testId));
                                                        }}>
                                                        {language("account-test-cancel")}
                                                    </LinkButton>
                                                </p>
                                            )}
                                        </div>
                                    </TestCard>
                                ))}
                            </div>
                        </>
                    ) : (
                        <LoadingAccount />
                    )}
                </div>
            </CenterContainer>
            <Footer />
        </>
    );
}
